import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function Forbidden() {
  return (
    <>
      <Helmet>
        <title>Adgang nægtet - Halsnæs Epoxygulve</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <section className="min-h-[70vh] flex items-center justify-center bg-white px-4 py-16">
        <div className="max-w-md w-full text-center space-y-6">
          <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-amber-50 text-amber-600 border border-amber-100">
            <i className="fa-solid fa-lock text-4xl"></i>
          </div>
          
          <div className="space-y-2">
            <h1 className="text-4xl font-extrabold text-brand-blue-900 tracking-tight">403 - Adgang nægtet</h1>
            <p className="text-sm text-concrete-500">
              Du har ikke tilladelse til at tilgå denne ressource.
            </p>
          </div>

          <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="w-full sm:w-auto inline-flex items-center justify-center rounded-lg bg-brand-blue-900 px-6 py-3 text-sm font-bold text-white shadow-sm hover:bg-brand-blue-800"
            >
              Gå til forsiden
            </Link>
            <Link
              to="/kontakt"
              className="w-full sm:w-auto inline-flex items-center justify-center rounded-lg border border-concrete-200 bg-white px-6 py-3 text-sm font-bold text-brand-blue-900 hover:bg-concrete-50"
            >
              Kontakt os
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
